import { Component } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';
import { IMedicalInfoDetailed } from '../../../../../../interfaces/MedicalInfo/IMedicalInfoDetailed';
import { CarePlanAddEditComponent } from './care-plan-add-edit/care-plan-add-edit.component';
import { CarePlanService } from '../../../../../../services/carePlan.service';
import { TranslateService } from '@ngx-translate/core';
import { COLORS } from 'src/styles/colors';
import { SwalToastService } from 'src/app/services/swal.service';
import { PermissionService } from 'src/app/services/permission.service';

@Component({
    selector: 'app-care-plan',
    templateUrl: './care-plan.component.html',
    styleUrls: ['./care-plan.component.css'],
    standalone: false
})
export class CarePlanComponent {
  public addComp = CarePlanAddEditComponent;

  private destroy$ = new Subject<void>();

  carePlans?: IMedicalInfoDetailed[];
  isLoading: boolean = false;

  constructor(
    private readonly carePlanService: CarePlanService,
    private readonly translate: TranslateService,
    private readonly swalToastService: SwalToastService,
    private readonly permissionService: PermissionService
  ) {}

  openModalFun(item?: IMedicalInfoDetailed) {
    this.carePlanService.carePlanModalSub.next(true);
    this.carePlanService.carePlanEditSub.next(item);
  }

  deleteFun(carePlanId: number) {
    Swal.fire({
      text: `${this.translate.instant(
        'deletePlaceholder1'
      )} ${this.translate.instant('Care Plan?')}?`,
      showDenyButton: false,
      showCancelButton: true,
      cancelButtonText: `${this.translate.instant('Cancel')}`,
      confirmButtonText: `${this.translate.instant('Ok')}`,
    }).then((result) => {
      if (result.isConfirmed) {
        this.carePlanService.deleteCarePlan(carePlanId.toString()).subscribe({
          next: (d) => {
            this.swalToastService.toastSuccess(
              'Care Plan deleted successfully'
            );
            this.carePlanService.deleteCarePlanFromTable(carePlanId.toString());
          },
          error: (err) => {
            this.swalToastService.toastError('Unable to delete care plan');
          },
        });
      } else if (result.isDenied) {
        Swal.fire(
          `${this.translate.instant('Care plan is not deleted')}`,
          '',
          'info'
        );
      }
    });
  }
  ngOnInit() {
    this.carePlanService.carePlanLoadingSub
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: boolean) => {
        this.isLoading = data;
      });

    this.carePlanService.carePlanDataSub
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: IMedicalInfoDetailed[]) => {
        this.carePlans = data;
      });

    this.carePlanService.getData();
  }

  hasPermission(permission: string[]): boolean {
    return this.permissionService.can(permission);
  }
}
